<p class="holiday-closures">{{ holidayClosuresDates | lxClosingDates }}</p>
